import styled, { css } from "styled-components";

// components
import { Image as CaretDownIcon } from "core/ReusableIcons/CaretDown";

// styles
import { UnstyledButton } from "core/Button/styles.js";
import { convertPxToRem } from "frontend/components/helpers";
export const AccordionStyled = styled.div``;

export const ControlStyled = styled(UnstyledButton)`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${convertPxToRem(6)};

    ${CaretDownIcon} {
        ${({ $isOpen }) => {
            if ($isOpen) {
                return css`
                    transform: rotate(180deg);
                `;
            }
        }}
    }
`;

export const ContentStyled = styled.div`
    overflow: hidden;
    max-height: ${({ $isOpen, $contentMaxHeight }) =>
        $isOpen ? convertPxToRem($contentMaxHeight) : "0"};
    transition: max-height 0.3s ease-out, padding 0.3s ease-out;
`;
